import React from 'react';
import {
    Typography,
    Chip,
    Box,
    Avatar,
} from "@mui/material";

import { _date, capitalize } from "../../../utils/helpers";

function getInitial(row) {
    const first = (row.first_name || '').trim()[0];
    const last = (row.last_name || '').trim()[0];
    return (first || last || '?').toUpperCase();
}

export const UserColumns = () => [
    {
        id: "name",
        label: "Name",
        render: (value, row) => {
            const initial = getInitial(row);
            return (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    {row.avatar ? (
                        <Avatar
                            src={row.avatar}
                            alt={`${row.first_name} ${row.last_name}`}
                            sx={{ width: 56, height: 56 }}
                        />
                    ) : (
                        <Avatar sx={{ width: 56, height: 56 }}>
                            {initial}
                        </Avatar>
                    )}
                    <Box>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {row.first_name} {row.last_name}
                        </Typography>
                        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                            {row.email}
                        </Typography>
                    </Box>
                </Box>
            );
        }
    },
    {
        id: "role",
        label: "Role",
        render: (value, row) => {
            const roleColors = {
                'super_admin': 'error',
                'admin': 'primary',
            };
            
            return (
                <Box sx={{ textAlign: 'center' }}>
                    <Chip 
                        label={capitalize(value.replace('_', ' '))} 
                        color={roleColors[value] || 'default'} 
                        size="small" 
                    />
                </Box>
            );
        }
    },
    {
        id: "email_verified_at",
        label: "Email Verified",
        render: (value, row) => {
            return (
                <Box sx={{ textAlign: 'center' }}>
                    <Chip 
                        label={value ? "Verified" : "Not Verified"} 
                        color={value ? "success" : "warning"} 
                        size="small" 
                    />
                </Box>
            );
        }
    },
    {
        id: "created_at",
        label: "Created Date",
        render: (value, row) => {
            return (
                <Typography sx={{ color: "text.secondary", textAlign: 'center' }}>
                    {_date(value, { relative: true })}
                </Typography>
            );
        }
    },
];
